import { useQuery } from '@tanstack/react-query';
import ServerError from '../../errors/ServerError';
import SM from '../../services/ServiceManager';

export const useGetInvestmentApp = ({
    containerOrApplicationId, language, isContainer, isEnabled = false,
}) => {
    const result = useQuery({
        queryKey: ['getInvestmentApplicationOverview', containerOrApplicationId, language, isContainer],
        enabled: isEnabled,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 3 * 1000, // 3 seconds
        gcTime: 3 * 1000, // 3 seconds
        queryFn: async () => {
            const { data } = await SM.customInvestmentService(
                'getInvestmentApplicationOverview',
                [{
                    containerOrApplicationId, language, isContainer,
                }],
            ) as any;

            return isContainer ? data : (data && [data]);
        },
    });

    return {
        ...result,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
